import { Component, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';

import { BaseComponent } from '../../../shared/abstracts/base.abstract';
import { ModalParentIdEnum, ModalType } from '../../../shared/enums';
import { ResetErrors } from '../../../shared/store/actions/errors.action';
import { ErrorsState } from '../../../shared/store/state/errors.state';
import { ErrorModalComponent } from '../error-modal/error-modal.component';
import { ModalService } from './../../../shared/services/internal/modal.service';

@Component({
    selector: 'app-error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.scss'],
})
export class ErrorComponent extends BaseComponent implements OnInit {
    @Select(ErrorsState.errors) public errors$: Observable<any[]>;

    constructor(private store: Store, private modalService: ModalService) {
        super();
    }

    ngOnInit(): void {
        this.uns = this.errors$.subscribe((errors: any[]) => {
            if (errors.length) {
                const isOwnError: boolean = this.store.selectSnapshot(ErrorsState.isOwnError);
                this.modalService.openModalWithComponent({
                    type: ModalType.STANDARD,
                    body: {
                        title: isOwnError ? 'ERRORS.HTTP.TITLE' : 'ERRORS.HTTP.TITLE-UNKNOWN',
                        cancelButtonFn: () => this.onClose(),
                    },
                    component: {
                        componentRef: ErrorModalComponent,
                        parentIdRef: ModalParentIdEnum.BODY_CONTENT,
                        config: {
                            inputs: {
                                errors,
                                isOwnError,
                            },
                        },
                    },
                });
                setTimeout(() => {
                    this.store.dispatch([new ResetErrors()]);
                    this.modalService.closeModal();
                }, 10000);
            }
        });
    }

    private onClose(): void {
        this.store.dispatch(new ResetErrors());
    }
}
